import axios from 'axios'
import store from '@/store'
import Vue from 'vue';
import { message as Message } from "ant-design-vue";


// src/utils/errorMessages.js
const errorMessages = {
    502: "服務器暫時無法處理您的請求，請稍後再試。",
    401: "您尚未登錄或會話已過期，請重新登錄。",
    404: "請求的資源不存在。",
    500: "服務器內部錯誤，請稍後再試。",
    default: "網絡請求失敗，請檢查網絡連接。"
};

const service = axios.create({
    // url = base url + request url
    baseURL: process.env.VUE_APP_BASE_API,
    // send cookies when cross-domain requests
    // withCredentials: true,
    // request timeout,
    timeout: 50000,
});

// 當前是否正在刷新 token 的標誌
let isRefreshing = false

// 待重試請求隊列
let requestsQueue = []



// 請求攔截器 (添加 token)
service.interceptors.request.use(
    config => {
        // 檢查會否是免認證接口
        config.noAuth = config.noAuth == undefined ? false : config.noAuth;//這裡是為了讓登錄驗證默認為false
        if (!config.noAuth) {
            const token = store.state.token
            if (token) {
                //config.headers.Authorization = `Bearer ${token}`;
                config.headers['Token'] = `${token}`;
            }
        }
        return config;
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// 響應攔截器 (處理 token 過期)
service.interceptors.response.use(
    //response => response,
    async response => {
        const { config, data } = response;
        const originalRequest = config
        // 檢測 token 過期 (狀態碼 401)
        if (!config.noAuth && (data.code === 10001 && !originalRequest._retry)) {
            originalRequest._retry = true;
            store.dispatch('logout')
            return Promise.reject(new Error('service error'));
        }
        if (data.code === 500) {
            // 網絡錯誤或其他錯誤
            return Promise.reject(new Error(`Request Service Failed: ` + (data.msg !== undefined && data.msg !== "" ? data.msg : "")));
        }

        return Promise.resolve(data);
    },
    async error => {
        if (error.response) {
            // 服務器返回了錯誤狀態碼
            const status = error.response.status;
            const message = errorMessages[status] || errorMessages.default;
            Message.error(message); // 使用 Element UI 的 Message 提示
        } else {
            // 網絡錯誤或其他錯誤
            Message.error(errorMessages.default);
        }
    }
)


export default service